export default __webpack_public_path__ + "static/media/information.c470bd0d.svg";